import React, { useEffect } from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import HeroSection from './components/HeroSection';
import CapabilityShowcase from './components/CapabilityShowcase';
import TrustBuilding from './components/TrustBuilding';
import IndustryExpertise from './components/IndustryExpertise';
import CTASection from './components/CTASection';
import ProcessOverview from './components/ProcessOverview';

const Homepage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-16">
        {/* <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
          <Breadcrumbs />
        </div> */}

        <HeroSection />
        <CapabilityShowcase />
        <TrustBuilding />
        <ProcessOverview />
        {/* <IndustryExpertise /> */}
        <CTASection />
      </main>

      <Footer />
    </div>
  );
};

export default Homepage;